/*
 * Copyright (C) 2024 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and
 * should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly
 * prohibited.
 */

import MuiPagination from '@mui/material/Pagination';
import { TablePaginationProps } from '@mui/material';
import { GridPagination, gridPageCountSelector, useGridApiContext, useGridSelector } from '@mui/x-data-grid';

function Pagination({
    page,
    onPageChange,
    className,
  }: Pick<TablePaginationProps, 'page' | 'onPageChange' | 'className'>) {
    const apiRef = useGridApiContext();
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);
  
    return (
        <MuiPagination
          color="primary"
          className={className}
          showFirstButton={true}
          showLastButton={true}
          count={pageCount}
          size="medium"
          shape='rounded'
          onChange={(event, newPage) => {
            onPageChange(event as any, newPage - 1);
          }}
        />
    );
  }
  
  const CustomGridPagination = () => {
    return (
        <GridPagination ActionsComponent={Pagination}  /> 
    );
  }

  export default CustomGridPagination;
